"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVersionAtLeast = exports.IDENTIFY_MIN_VERSION = void 0;
const Sensor_1 = require("../types/Sensor");
/**
 * First sensor firmware, per SKU, that blinks its LED ring on Identify
 * (`identifySensor` → hub → ZPC Identify → Indicator CC 0x50). Older builds
 * accept the command and light nothing, so the app greys the button out below
 * these. Keep in step with each SKU branch's `home_guardian_version.h` in
 * home_guardian_end_device. A type missing here can't blink at all.
 */
exports.IDENTIFY_MIN_VERSION = {
    [Sensor_1.SensorType.LEAK_DETECTOR]: '1.16.0',
    [Sensor_1.SensorType.WATER_QUALITY]: '1.13.0',
    [Sensor_1.SensorType.AIR_QUALITY]: '1.12.0',
    [Sensor_1.SensorType.POWER]: '1.12.0',
    [Sensor_1.SensorType.POWER_ALT]: '1.12.0',
    [Sensor_1.SensorType.HVAC_CONDENSER_MONITOR]: '1.12.0',
    [Sensor_1.SensorType.HVAC_AIRHANDLER_MONITOR]: '1.13.0',
};
const versionParts = (v) => {
    const m = v.match(/\d+(?:\.\d+)*/);
    return m ? m[0].split('.').map(Number) : null;
};
/**
 * True when `version` (as the sensor reports it: `x.y.z`, or `x.y` from ZPC) is
 * at least `min`. Missing parts count as 0; a missing or unparseable version is
 * treated as too old.
 */
const isVersionAtLeast = (version, min) => {
    const a = version ? versionParts(version) : null;
    const b = versionParts(min);
    if (!a || !b)
        return false;
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
        const d = (a[i] ?? 0) - (b[i] ?? 0);
        if (d !== 0)
            return d > 0;
    }
    return true;
};
exports.isVersionAtLeast = isVersionAtLeast;
